import { render, staticRenderFns } from "./Enindependence.vue?vue&type=template&id=46456708&scoped=true"
import script from "./Enindependence.vue?vue&type=script&lang=js"
export * from "./Enindependence.vue?vue&type=script&lang=js"
import style0 from "./Enindependence.vue?vue&type=style&index=0&id=46456708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46456708",
  null
  
)

export default component.exports